<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { AlertDialogTitle, type AlertDialogTitleProps } from 'reka-ui';
    import { cn } from '@/lib/utils';

    const props = defineProps<AlertDialogTitleProps & { class?: HTMLAttributes['class'] }>();

    const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
    <AlertDialogTitle
        data-slot="alert-dialog-title"
        v-bind="delegatedProps"
        :class="cn('font-semibold', props.class)"
    >
        <slot />
    </AlertDialogTitle>
</template>
